import { o_global } from "@gr-common/async/namespaces";
import { otto } from "@gr-exports/async/nexus";
const device = o_global.device ?? {};
const browser = device.browser;
const hybrid = device.hybrid;
const orientation = device.orientation;
const os = device.os;
const type = device.type;
const deviceAsync = otto.device ?? {};
const getPointerType = deviceAsync.getPointerType;
const getScreenSpecs = deviceAsync.getScreenSpecs;
export {
  browser,
  device,
  deviceAsync,
  getPointerType,
  getScreenSpecs,
  hybrid,
  orientation,
  os,
  type
};
